import JiaMengHeader from '@components/JiaMeng/Header/MarketingCenter'
import Home from '@components/LocalMerchant/RegistrationActivity/Home'
import {
  MARKETING_PRODUCT_DETAIL_PATH,
  PRODUCT_REGISTRATION_ACTIVITY
} from '@constant'
import { isOnlineShop, isUltimate } from '@merchant-backend/util'

export default {
  path: 'registrationActivity',
  component: JiaMengHeader,
  onEnter(nextState, replaceState, cb) {
    if (!isUltimate() && !isOnlineShop()) {
      // 不是旗舰版
      replaceState(
        `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_REGISTRATION_ACTIVITY}`
      )
    }
    cb()
  },
  indexRoute: {
    component: Home
  },
  stat: '微传单+/首页'
}
